import { get } from '@common/Http';
import { minuteInMilliseconds } from '@helpers/Date';
import {
    get as lsGet,
    set as lsSet,
    remove as lsRemove
} from '@helpers/localStorage';
import { loadSession, saveSession } from '@helpers/sessionStorage';
import { getFavoriteBrandsLastUpdated, getVisitorId } from '@helpers/visitor';
import { API_FAVORITE_BRAND_LIST_FAVORITE_JSON } from '@routes';

const fetchFavorites = async (updatedHash, lsKey, visitorId, callback) => {
    let response = await get(API_FAVORITE_BRAND_LIST_FAVORITE_JSON, {
        visitorId,
        timestamp: updatedHash
    });

    response.key = updatedHash;
    response = JSON.stringify(response);

    lsSet(lsKey, response);
    saveSession('session.favoriteBrands', Date.now());

    if (typeof callback === 'function') {
        callback(JSON.parse(response));
    }
};

/**
 * Gets favorite brands from localstorage or fetch them from database
 * @param {function} callback           - Callback function for processing the returned value
 * @returns boolean|Object
 */
export const fetchFavoriteBrands = (callback) => {
    const visitorID = getVisitorId();
    const key = 'favoriteBrandJSON';
    const updatedHash = getFavoriteBrandsLastUpdated();

    if (!visitorID) {
        return false;
    }

    let response = lsGet(key);

    if (response == null) {
        return fetchFavorites(updatedHash, key, visitorID, callback);
    }

    const session = loadSession('session.favoriteBrands');
    const expired = (minuteInMilliseconds * 10) + session < Date.now();
    response = JSON.parse(response);

    if (!session || expired || response.key !== updatedHash) {
        lsRemove(key);
        return fetchFavorites(updatedHash, key, visitorID, callback);
    }

    if (typeof callback === 'function') {
        callback(response);
    }

    return true;
};
